<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
    var dropdowns = document.querySelectorAll('.menu-lv-item.dropdown > a');

    dropdowns.forEach(function(dropdown) {
        dropdown.addEventListener('click', function(e) {
            var parent = dropdown.parentElement;
            if (parent.querySelector('.submenu')) {
                e.preventDefault();
                parent.classList.toggle('active');
            }
        });
    });
});